export default {
  'component': {
    'tradeInProcess': {
      '649f8aefats0': 'Encomenda expirada',
      '649f8aefc1c0': 'Falha na retoma',
      '649f8aefc9c0': 'Vender agora',
      'TradeIn': 'Processo de retoma',
      'logistic': 'Transferir etiqueta de envio',
      'start': 'Começar',
      'success': 'A sua encomenda foi efetuada com sucesso no nosso site.',
      'qc': 'Inspeção do dispositivo antigo',
      'business': 'Concluiremos a inspeção do seu dispositivo antigo no prazo de 1–2 dias úteis',
      'completed': 'Concluído',
      'successfully': 'Parabéns! A sua retoma foi concluída com sucesso.',
      'orderInfor': 'Informações da encomenda',
      'orderID': 'Número da encomenda de retoma',
      'orderNum': 'New device purchase order ID',
      'createTime': 'Data de criação',
      'brand': 'Marca estimada',
      'model': 'Modelo',
      'price': 'Preço do dispositivo antigo',
      'bonus': 'Bónus',
      'reclaimFailure': 'Como o dispositivo não foi enviado no prazo de 10 dias, a encomenda de retoma expirou e foi cancelada. Se ainda pretender concluir a retoma do dispositivo antigo, clique no botão abaixo para consultar a oferta mais recente.',
      'total': 'Preço total',
      'logisticInfo': 'Informações logísticas',
      'available': 'Não existem informações logísticas disponíveis',
      'logisticNum': 'Número de rastreio',
      'failRey': 'Lamentamos que a sua participação no programa de retoma OnePlus não tenha sido concluída com sucesso. Se pretender vender outros produtos eletrónicos, clique no botão abaixo para obter uma avaliação rápida.',
      'userRes': 'O utilizador já rejeitou a oferta.',
      'successPrice': 'O preço abaixo resulta de uma inspeção profissional. Se concordar com este preço, poderá prosseguir com a retoma. Se o rejeitar, o dispositivo ser-lhe-á devolvido no prazo de alguns dias úteis.',
      'sure': 'Aceitar',
      'Reject': 'Rejeitar',
      'congratulation': 'Parabéns! A inspeção não identificou diferenças.',
      'finPirce': 'Preço final',
      'copySuccess': 'Copiado com sucesso',
      'copyfail': 'Falha ao copiar',
      'sureSuccess': 'Confirmar transação bem-sucedida',
      'submitError': 'Falha no envio',
      'detectionResult': 'Resultado da inspeção',
      'Collected': 'Recolhido',
      'inTransit': 'Em trânsito/Envio',
      '656g0lj3sav6': 'recycling process',
      '656g0lj3cd5a': 'Preencha corretamente os seus dados pessoais e conclua a encomenda com sucesso',
      '656g0lj3dr9a': 'A inspeção do seu telemóvel será concluída no prazo de 48 horas após a chegada ao nosso centro',
      '656g0lj3epal': 'Assim que a inspeção estiver concluída, entraremos em contacto consigo por e-mail com uma oferta final',
      '656g0lj3pda2': 'A sua avaliação',
      '656g0lj3ed3d': 'Inspeção de qualidade profissional',
      '656g0lj3esf3': 'Copiar',
      'expertDiscount': 'Bónus do código promocional',
      'invalidCode': 'Código inválido',
      'toastTip': 'Assinale para aceitar a Política de Privacidade e os Termos e Condições.',
      '649f8aef26sf': 'Trade-in process',
      'checkTitle': 'Informações da inspeção',
      'basicInformation': 'Informações básicas',
      'understand': 'Compreendo',
      '656g0lj3sf6e': 'Promotional bonuses are offered and managed by the associated brands. They will be paid separately and are not part of the valuation of the old device.'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Recusar a retoma',
      '64a9shqq3k00': 'Confirma que recusa a retoma',
      '64a9shqq3r00': 'Cancelamento efetuado com sucesso',
      '64a9shqq3ws0': 'Falha ao cancelar',
      'sureCancel': 'Confirmar cancelamento'
    }
  },
  'home': {
    'whoAreWe': {
      '646u995ltgw0': 'Quem',
      '646u995lv9g0': 'somos?',
      '646u9d5lv9g0': 'A eSwop é uma empresa cuja atividade principal se centra na retoma, tratamento e venda de produtos digitais 3C, como telemóveis, tablets, computadores portáteis e relógios. Dedicamo-nos a aumentar a eficiência da reutilização de produtos eletrónicos e a promover o desenvolvimento saudável do mercado de segunda mão. Atualmente, estabelecemos parcerias estratégicas oficiais com a OPPO, Vivo, OnePlus, Realme, entre outras. A nossa atividade internacional expandiu-se para a Índia, Tailândia, Vietname, Camboja e, agora, Europa.',
      '646u995dv9g0': 'A nossa presença global posicionou-nos como parceiro estratégico de operadores móveis, fabricantes e grossistas com alcance continental e transcontinental.',
      '646u99slv9g0': 'Colaboramos com fabricantes líderes e mantemos um inventário diversificado que inclui dispositivos de gama baixa, média e alta. Isto permite-nos oferecer soluções personalizadas e preços competitivos para responder às necessidades dos nossos clientes.'
    },
    'business': {
      '646v04syvpk0': 'Tem interesse em comprar o nosso stock?',
      '646v04syxs80': 'Na eSwop, disponibilizamos uma ampla seleção de telemóveis, tablets e smartwatches em vários níveis de classificação, para responder a diferentes necessidades empresariais.',
      '646v04syy6g0': 'Contacte o nosso Gestor de Vendas e Compras:',
      '646v04syya80': 'Quero comprar',
      '646v04syydg0': 'Introduza o seu nome',
      '646v04syyh40': 'Introduza o seu número de telefone',
      '646v04syyyw0': 'Introduza o seu e-mail',
      '646v0gsyz1s0': 'País:',
      '646v04syz1s0': 'Selecione uma opção',
      '646v04syz4o0': 'Li e aceito a',
      '646v04syzkc0': 'Política de Privacidade',
      '646v04syzok0': 'Contacte-nos',
      '646v04syzvo0': 'Introduza o seu número de telemóvel',
      '646v04syzys0': 'Introduza o e-mail',
      '646v04sz01o0': 'Introduza um e-mail válido',
      '646v04sz04g0': 'Introduza o seu nome',
      '646v04sz0740': 'Assinale a caixa para aceitar a Política de Privacidade',
      '646v04sz0a00': 'Enviado com sucesso',
      '646v04sz0cw0': 'Falha no envio',
      'title1': 'Classificação transparente de dispositivos móveis',
      'text1-1': 'Para apoiar as suas decisões de compra, recomendamos a consulta do nosso documento detalhado de Classificação. Este apresenta os padrões estéticos e funcionais de cada categoria, permitindo-lhe tomar decisões informadas e alinhadas com as suas expectativas.',
      'title2': 'Apoio excecional ao cliente',
      'text2-1': 'Reconhecemos as necessidades específicas de cada cliente. Por isso, a nossa equipa multilingue de profissionais de vendas dedica-se a prestar um apoio especializado e personalizado.',
      'title3': 'Compromisso com a tecnologia sustentável',
      'text3-1': 'Estamos empenhados em ampliar o acesso global a soluções tecnológicas sustentáveis, garantindo que os nossos processos criem valor para todas as partes envolvidas.',
      'text3-2': 'Para mais informações ou para organizar uma encomenda de teste, contacte-nos. A nossa equipa está pronta para o ajudar com profissionalismo e atenção.'
    }
  },
  'components': {
    'section2': {
      '646tj9dnkk00': 'Apenas 4 passos para receber rapidamente',
      's1': 'Primeiro passo',
      's1t': 'Embale o dispositivo de forma a que chegue nas mesmas condições em que foi enviado.',
      's2': 'Segundo passo',
      's2t': 'Entregue a sua encomenda no nosso ponto de entrega.',
      's3': 'Terceiro passo',
      's3t': 'Vamos inspecionar o seu dispositivo e apresentar-lhe uma oferta.',
      's4': 'Quarto passo',
      's4t': 'Receba rapidamente.'
    },
    'section3': {
      '646tmse2fbo0': 'Telemóveis',
      '646tmse2mv00': 'Stay tuned',
      'section3-text2': 'Tablets',
      'section3-text4': 'Relógios',
      'section3-text5': 'Outros',
      'title': 'Avaliação rápida',
      't1': 'Selecione o tipo e inicie a avaliação para obter uma oferta justa.',
      't2': 'Passos simples para usufruir do nosso serviço rápido de retoma!'
    },
    'section6': {
      '646txzpazuc0': 'Sobre a empresa',
      '666txzpazuc0': 'A eSwop é uma empresa especializada na retoma e reutilização de telemóveis e tablets, empenhada em tornar a reutilização de dispositivos simples para todos através de um processo de serviço simples, seguro e eficiente.',
      '646txzpb0rk0': 'Ver detalhes',
      '646txzpb0xc0': 'Suporta 12 marcas para retoma'
    },
    'section7': {
      '646ns2k5f7k0': 'Estamos ao seu dispor',
      '646ns2k5gmw0': 'De segunda a sexta-feira, das 9:00 às 18:00 CET (UTC+01:00), Madrid, Espanha',
      '646ns2k5gs40': 'Introduza o seu nome',
      '646ns2k5gx40': 'Introduza o seu número de telefone',
      '646ns2k5img0': 'Introduza o seu e-mail',
      '646ns2k5isw0': 'Deixe a sua mensagem',
      '646ns2k5iws0': 'Contacte-nos',
      '646ns2k5j140': 'Introduza o seu número de telemóvel',
      '646ns2k5j4g0': 'Introduza o e-mail',
      '646ds2k5j4g0': 'E-mail',
      '646ns2k5j6c0': 'Introduza um e-mail válido',
      '646ns2k5j8g0': 'Telefone de contacto',
      '646ns2k5jak0': 'Número de identificação fiscal',
      '646ns2k5jck0': 'Morada',
      '646ns2s5jck0': 'Calle Tomás Bretón, 46, Planta 1, Oficina 5, 28045 Madrid, Espanha',
      '646ns2k5jgc0': 'Introduza o seu nome',
      '646ns2k5ji40': 'Assinale a caixa para aceitar a Política de Privacidade',
      '646ns2k5jk00': 'Enviado com sucesso',
      '646ns2k5jm80': 'Falha no envio',
      '646ny1rgz3c0': 'Li e aceito',
      '646ny1rh2k40': 'Política de Privacidade'
    },
    'successMain': {
      '647qmd42l1s0': 'Encomenda efetuada com sucesso!',
      '647qmd42mss0': 'Consulte o e-mail com as instruções de envio enviado por noreply@eswop.eu',
      '647qmd42mz80': 'Valor estimado',
      '647qmd42yeo0': 'Nota importante',
      'orderTime': 'Data da encomenda',
      'text1': 'Envio gratuito',
      'text2': 'Consulte no seu e-mail a etiqueta/documento de envio que lhe foi enviado',
      'text3': 'Cópia de segurança dos dados',
      'text4': 'Para proteger os seus dados, apagaremos todos os dados ou reporemos o dispositivo para as definições de fábrica',
      'text5': 'Carregamento',
      'text6': 'Para agilizar a inspeção, carregue antecipadamente o seu telemóvel antigo',
      'downloadDec': 'Transfira a Declaração de Integridade'
    },
    'tradeInProcess': {
      '649f8aefats0': 'Order Timeout',
      '649f8aefc1c0': 'Recycling Failed',
      '649f8aefc9c0': 'Get a New Quote',
      'TradeIn': 'Trade-in process',
      'logistic': 'Download shipping label',
      'start': 'Start Journey',
      'success': 'You have successfully signed for the new machine',
      'qc': 'Old Device QC',
      'business': 'We will complete your old device inspection within 3 working days',
      'completed': 'Completed',
      'successfully': 'Congratulations your trade-in are successfully',
      'orderInfor': 'Order information',
      'orderID': 'Recycling order number',
      'orderNum': 'New device purchase order ID',
      'createTime': 'Creation time',
      'brand': 'Estimated brand',
      'model': 'model',
      'price': 'Old device price',
      'bonus': 'Bonus',
      'total': 'Total price',
      'logisticInfo': 'Logistics information',
      'available': 'No logistics information available',
      'logisticNum': 'Logistics number',
      'failRey': 'We apologize that your participation in the OnePlus recycling program was not successfully completed. If you have a recycling plan for other electronic products, you can click the button below for a quick estimate!!',
      'userRes': 'The user has already rejected the offer.',
      'successPrice': 'The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.',
      'sure': 'Accept',
      'Reject': 'Reject',
      'congratulation': 'Congratulations QC No difference.',
      'finPirce': 'Final price',
      'copySuccess': 'Copy Success',
      'copyfail': 'Copy Failure',
      'sureSuccess': 'Confirm successful transaction',
      'submitError': 'Submission failed',
      'detectionResult': 'detection result',
      'Collected': 'Collected',
      'inTransit': 'In transit/Shipping',
      'understand': 'I understand',
      '656g0lj3sf6e': 'Os bónus promocionais são oferecidos e geridos pelas marcas associadas. Serão pagos separadamente e não fazem parte da avaliação do dispositivo antigo.'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Refuse to recycle',
      '64a9shqq3k00': 'You confirm that you refuse to recycle',
      '64a9shqq3r00': 'Cancel Success',
      '64a9shqq3ws0': 'Cancellation failed',
      'sureCancel': 'Confirm cancel'
    }
  },
  'shippingLable': {
    'shippingLable': {
      'firstStep': 'Informações pessoais',
      '649fhwp9zbo0': 'Carregue uma fotografia nítida da sua encomenda',
      '649fhwpa1900': 'Transferir a etiqueta de envio',
      '649fhwpa1l00': 'Transferir a etiqueta de envio',
      '649fhwpa1tc0': 'Concluir a entrega',
      '649fhwpa2100': 'Fotografia da encomenda e Declaração de Integridade',
      '649fhwpa2880': 'Exemplo de colocação da etiqueta de envio',
      '649fhwpa2h80': 'Nota',
      '649fhwpa2qk0': 'Embalagem: envolva o telemóvel em plástico-bolha e preencha a caixa com papel para evitar danos durante o transporte.',
      '649fhwpa2xs0': 'Fill gaps with protective padding to prevent damage.',
      '649fhwpa3fk0': 'Etiqueta de envio: leve a etiqueta (digital ou impressa) ao ponto de entrega; a etiqueta oficial será impressa no local.',
      '649fhwpa3v40': 'Envie o seu telemóvel usado o mais rapidamente possível. Se não for enviado no prazo de 10 dias de calendário, a encomenda será cancelada.',
      '649fhwpa42s0': 'Consultar pontos de entrega',
      '649fhwpa4as0': 'Transferir a etiqueta',
      '649fhwpa4jo0': 'Carregar',
      '649fhwpa4ok0': 'Início',
      '649fhwpa4to0': 'Enviado com sucesso',
      '649fhwpa4yk0': 'Parabéns, a transferência foi concluída com sucesso!',
      '649fhwpasf3s': 'Atenção',
      '649fhwpaa6f3': 'Imprima e assine a Declaração de Integridade. Em seguida, tire uma fotografia da declaração juntamente com a embalagem do dispositivo antigo e carregue-a.'
    }
  },
  'bottom': {
    'index': {
      '646d51qugz40': 'Redes sociais',
      '646d71qugz40': 'Pagamento fácil',
      '646u51qugz40': 'Logística',
      '646u5dqui780': 'Política de Privacidade',
      '646uddqui780': 'Termos e Condições',
      '646u51qui780': 'Perguntas frequentes'
    }
  },
  'head': {
    'index': {
      '646nt7hwh0c0': 'Sobre a eSwop',
      '646ntjwmn580': 'Negócios',
      '646nt7hwils0': 'Contacte-nos',
      '646nt7hwipg0': 'Comprar',
      '646nt7hwis00': 'Vender'
    }
  },
  'PCModelList': {
    'index': {
      '646wfv5g0ro0': 'Avaliação gratuita'
    }
  },
  'PCSearch': {
    'index': {
      '646wgb1ni8k0': 'Introduza',
      '646wgb1nj8o0': 'Termo de pesquisa',
      '646wgb1nji80': 'A pesquisa foi acionada',
      'empty': 'Nenhum modelo disponível de momento',
      'confirm': 'Confirmar',
      'cancle': 'Cancelar',
      'dialogText': 'Tem a certeza de que pretende eliminar todo o histórico?'
    }
  },
  'PCProduct': {
    'empty': 'Nenhum modelo disponível de momento'
  },
  'PCBrandTab': {
    'index': 'Marca'
  },
  'PCCategoryTab': {
    'index': 'Categoria'
  },
  'PCOrderStep': {
    'index': {
      '646xagqwff40': 'Faça a encomenda online',
      '646xagqwkuw0': 'Envio gratuito pela plataforma',
      '646xagqwmao0': 'Inspeção profissional',
      '646xagqwmlc0': 'Pagamento rápido'
    }
  },
  'PCBreadNav': {
    'index': {
      '646xgup6ugg0': 'Início'
    }
  },
  'router': {
    'selectModel': 'Modelo',
    'selectProperty': 'Perguntas sobre o estado do dispositivo',
    'price': 'Valor estimado',
    'priceOrder': 'Fazer encomenda',
    'orderSuccess': 'Encomenda efetuada com sucesso'
  },
  'PCDeviceInfo': {
    'index': {
      '646ymq6orm00': 'Selecionar novamente o modelo',
      '646ymq6ot0k0': 'Aviso',
      '646ymq6pd100': 'Antes de vender, certifique-se de terminar sessão na conta cloud/',
      '646ymq6pekw0': 'bloqueio de ecrã/conta Apple ID do dispositivo antigo.'
    }
  },
  'PCModelInfo': {
    'index': {
      '646yn085ljk0': 'Selecione o estado do dispositivo',
      '647h1f4yr6c0': 'Valor estimado de retoma',
      '647h1f4yso80': 'Bónus estimado',
      'text1': 'Free shipping',
      'text2': 'Ofrecemos un servicio de logística y envío gratuito',
      'text3': 'Immediate payment',
      'text4': 'We will make the payment within 1-2 business days once we have received your used device.',
      '64tve23zt0g0': 'Envio e embalagem gratuitos',
      '64tve23zup00': 'Eliminação segura de dados',
      '64tve23zuy40': 'Não está satisfeito? Devolução gratuita',
      '64tve23zv7g0': 'Pagamento em 1–2 dias úteis após a receção do dispositivo',
      '64tve23zvbg0': 'Escolha o método de envio',
      '64tve23zvf80': 'Tem 10 dias para enviar o seu telemóvel',
      '64tve23zvjc0': 'Enviaremos a etiqueta de envio para o seu e-mail para que possa enviar o telemóvel gratuitamente.',
      '64tve23zvms0': 'Imprima a etiqueta de envio e cole-a numa embalagem almofadada.',
      '64tve23zvqg0': 'Atenção:',
      '64tve23zvyo0': 'Devido às restrições de transporte relacionadas com baterias de lítio, não envie o telemóvel se suspeitar que a bateria possa estar defeituosa ou danificada.',
      '64tve23zwak0': 'Não podemos devolver acessórios ou embalagens enviados juntamente com o dispositivo.',
      '64tve23zwgs0': 'Próximos passos para vender o seu telemóvel',
      '64tve23zwm80': 'Preencha os seus dados de contacto',
      '64tve23zwt00': 'Prepare o seu telemóvel para envio',
      '64tve23zwwk0': 'O seu dispositivo será inspecionado à chegada. Se as informações fornecidas não forem exatas, enviaremos uma nova oferta. Poderá aceitá-la ou receber o seu telemóvel de volta gratuitamente.'
    }
  },
  'PCPropertyList': {
    'index': {
      '646ynp3udds0': '购买渠道',
      '646ynp3ueas0': '需要激活，无法正常通话',
      '646ynp3uehw0': 'Introduza o IMEI do seu telemóvel',
      '646ynp3uem40': 'Marque *#06# no teclado de chamadas para consultar o IMEI do telemóvel'
    }
  },
  'PCButton': {
    'index': {
      '646zhxujd5g0': 'Ver avaliação'
    }
  },
  'PCBottomButton': {
    'index': {
      '647hqss75ac0': 'Nota: o preço de venda de telemóveis/produtos eletrónicos diminui 6% por semana. Recomendamos que venda o mais rapidamente possível.',
      '647hqss760c0': 'Assinale para aceitar',
      '647hqss764w0': 'Política de Privacidade',
      '647hqss76ac0': 'Política de Serviço',
      '647hqss76dg0': 'Quero fazer uma encomenda',
      '647hqss76gw0': 'Preço de transação estimado',
      'text1': 'Preço de transação estimado',
      'text2': 'Valor estimado',
      'text3': 'Bónus',
      'dialogTitle': 'Aviso',
      'dialogText': 'Clique no botão Confirmar e consulte o seu e-mail para saber os próximos passos.',
      'dialogBtn': 'Confirmar'
    }
  },
  'PCUserInfo': {
    'index': {
      '647kboa03ks0': 'Informações da encomenda',
      '647kboa06ys0': 'Nome',
      '647kboa0d6v8': 'Código do país',
      '647kboa078s0': 'Número de telemóvel',
      '647kboa07d00': 'Endereço de envio',
      '647kboa07jk0': 'País',
      '647kboa07p80': 'Selecione',
      '647kboa08b40': 'Código postal',
      '647kboa08h00': 'Cidade',
      '647kboa08zc0': 'Morada completa',
      '647kboa09440': 'Informações de pagamento',
      '647kboa096w0': 'Verificação do e-mail',
      '647kboa09ao0': 'Endereço de e-mail',
      '647kboa09dk0': 'Código de verificação',
      '647kboa09u40': 'Introduza',
      '647kboa09z80': 'Enviar código de verificação',
      '647kboa0ak00': 'Introduza um endereço de e-mail válido',
      '647kboa0aog0': 'Enviado com sucesso',
      'send': 'Enviado',
      'submit': 'Enviar',
      'error': 'Código de verificação incorreto',
      '64jjt96fg400': 'Introduza o código de verificação',
      '64jjt96fki00': 'Obtenha o código de verificação',
      'idNumber': 'Número do documento de identificação / Número de identificação',
      'declaration': 'Declaração de Integridade',
      'download': 'Transferir',
      '647kboa0idc0': 'Número de identificação pessoal',
      '647kboa0idc1': '(o número oficial de identificação emitido pelo seu país, utilizado para identificação em procedimentos legais, fiscais ou administrativos. Pode ser o seu DNI, NIE, Codice Fiscale, Personalausweisnummer, CNP ou outro documento nacional equivalente, consoante o seu país de residência.)',
      '647kboa0idc2': '(o número oficial de identificação emitido pelo seu país, utilizado para identificação em procedimentos legais, fiscais ou administrativos. Pode ser o seu DNI, NIE, Codice Fiscale, Personalausweisnummer, CNP ou outro documento nacional equivalente, consoante o seu país de residência.)',
      'idError': 'Número de identificação inválido',
      'ibanTip': 'Utilizado para receber o pagamento pelo dispositivo antigo.',
      'downloadDec': 'Por favor, transfira a Declaração de Integridade.',
      'addreddPlaceholder': 'Este campo suporta no máximo 105 caracteres'
    }
  },
  'successOrder': {
    'successOrder': {
      '647s39cv77s0': 'Voltar ao início',
      'notRecyclable': 'Este tipo de dispositivo não é elegível para retoma',
      'IKnow': 'Entendi',
      'tips': 'Dicas'
    }
  },
  'blog': {
    'blogList': {
      '64wgr171lsk0': 'Ver',
      '64wgr171nq40': 'Nenhum registo relacionado',
      '64wgr171av65': 'Date'
    },
    'blogDetail': {
      '64wgr9y5r7s0': 'Ver',
      '64wgr171wdx9': 'Detalhes do artigo'
    }
  },
  'cookieNotice': {
    'title': 'Aviso sobre a utilização de cookies',
    'description': 'Utilizamos cookies para melhorar a sua experiência de navegação. Ao continuar a utilizar este site, concorda com a nossa',
    'cookiePolicy': 'Política de Cookies',
    'acceptAll': 'Aceitar todos os cookies',
    'acceptNecessary': 'Aceitar apenas cookies necessários',
    'customize': {
      'title': 'Selecione os tipos de cookies que pretende aceitar:',
      'necessary': {
        'label': 'Cookies necessários',
        'description': 'Estes cookies são necessários para o funcionamento do site e não podem ser desativados.'
      },
      'analytics': {
        'label': 'Cookies analíticos',
        'description': 'Estes cookies ajudam-nos a compreender como os visitantes interagem com o nosso site.'
      },
      'marketing': {
        'label': 'Cookies de marketing',
        'description': 'Estes cookies são utilizados para acompanhar a atividade dos visitantes em diferentes sites e apresentar publicidade relevante.'
      }
    },
    'save': 'Guardar definições',
    'cancel': 'Cancelar'
  },
  'model': {
    'answerTip01': 'Pode encontrar o modelo do telemóvel em | [Definições] - [Geral] - [Informações regulamentares] |',
    'answerTip02': 'Os modelos que começam por N são unidades de substituição oficial; os que começam por F são unidades recondicionadas/reparadas oficialmente; os que começam por 3 são unidades de exposição.',
    'answerTip03': 'Bloqueado ou desbloqueado?',
    'answerTip04': 'Insira outro cartão SIM e verifique se consegue fazer chamadas normalmente para determinar se o dispositivo está bloqueado. Os dispositivos bloqueados normalmente requerem ativação e não permitem chamadas normais.',
    'answerTip05': 'CH indica um dispositivo destinado ao mercado chinês e ZP ao mercado de Hong Kong. Se não for CH/ZP, trata-se de outra versão regional.'
  },
  'other': {
    'chooseOrNot': 'Opcional',
    'clickTakePhoto': 'Clique para tirar uma fotografia',
    'loadFail': 'Falha ao carregar',
    'shiliTu': 'Imagem de exemplo',
    'tip': 'Aviso',
    'yesISure': 'Sim, confirmo'
  }
}
